import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { useMap as I, Map as O, AdvancedMarker as _ } from "@vis.gl/react-google-maps";
import { UserPositionMarker as b } from "../user-position-marker/user-position-marker.js";
import r from "./map-view.module.less.js";
import { ZoomControls as C } from "../../../../../components/elements/zoom-controls/zoom-controls.js";
import { ClusteredMarkers as D } from "../clustered-markers/clustered-markers.js";
import { useMapViewport as N } from "../../../hooks/use-map-viewport.js";
import { useCallback as d } from "react";
import { useTranslation as k } from "react-i18next";
import { PANEL_WIDTH_OFFSET as L } from "../../../find-station.js";
import { isMobileDevice as z } from "../../../../../helpers/device-helper.js";
import "dayjs";
const i = 15, s = 5, A = { lat: 59.69067, lng: 14.39834 }, h = 6, W = ({
  stations: c,
  selectedStation: f,
  userPosition: a,
  onClickItem: l,
  onDragStart: u,
  onDragEnd: M,
  onClickMap: T
}) => {
  const t = I("station-map"), { t: Z } = k(), { zoom: n } = N(), g = d(
    (o, m) => {
      typeof l == "function" && l(o, m);
    },
    [l]
  ), E = d(
    (o, m) => {
      t?.panTo(m), t?.setZoom(o);
    },
    [t]
  );
  return /* @__PURE__ */ p("div", { className: r.wrapper, children: [
    /* @__PURE__ */ p(
      O,
      {
        id: "station-map",
        defaultZoom: h,
        defaultCenter: A,
        maxZoom: i,
        minZoom: s,
        gestureHandling: "greedy",
        disableDefaultUI: !0,
        mapTypeId: "roadmap",
        mapId: "3ab6c52371682fb5",
        onDragstart: u,
        onDragend: M,
        clickableIcons: !1,
        onClick: T,
        children: [
          c && /* @__PURE__ */ e(
            D,
            {
              selectedStation: f,
              stations: c,
              onClickStation: g,
              onClickCluster: E
            }
          ),
          a && /* @__PURE__ */ e(_, { position: a, title: Z("FIND_STATION_POSITION_MARKER_TITLE"), zIndex: 1, children: /* @__PURE__ */ e(b, {}) })
        ]
      }
    ),
    /* @__PURE__ */ e(
      "button",
      {
        disabled: !a,
        className: r.userPositionButton,
        onClick: () => {
          a && (z() ? t?.panTo({ lat: a.lat, lng: a.lng }) : (t?.setCenter({ lat: a.lat, lng: a.lng }), t?.panBy(L * -1, 0)));
        },
        children: /* @__PURE__ */ e(
          "span",
          {
            className: [r.icon, a ? "ui-icon-location-filled" : "ui-icon-location-disabled"].join(" ")
          }
        )
      }
    ),
    /* @__PURE__ */ e("div", { className: r.zoomControlsWrapper, children: /* @__PURE__ */ e(
      C,
      {
        zoomInDisabled: !!(n && n >= i),
        zoomOutDisabled: !!(n && n <= s),
        onZoomIn: () => {
          const o = t?.getZoom();
          o && o < i && t?.setZoom(o + 1);
        },
        onZoomOut: () => {
          const o = t?.getZoom();
          o && o > s && t?.setZoom(o - 1);
        }
      }
    ) })
  ] });
};
export {
  W as MapView,
  W as default
};
